/**
 * ч.1303 — кнопка «зберегти в Excel» друкованої форми (рішення власника 2026-10-16):
 * сторінка розбирає свою розмітку `.print-page` (printToXlsx), сервер складає книгу,
 * браузер зберігає файл. Стоїть поруч із «друкувати» у PrintActions і на формах з
 * власним тулбаром (ПН, декларація ПДВ, ВМД, додаткові витрати, коригування боргу).
 */
import { useState } from 'react';
import { printExport } from '@/api/printExport';
import { defaultPrintFilename, extractPrintSheet } from '@/shared/utils/printToXlsx';
import { saveBlob } from '@/shared/utils/download';

export default function SaveXlsxButton({ filename, rootSelector = '.print-page', build }: {
  /** Базове імʼя файла (без розширення), напр. «Видаткова РН-12». */
  filename?: string | null;
  rootSelector?: string;
  /** ч.1373: форма з власною книгою (рахунок за зразком 1С) — складає файл сама, без розбору розмітки. */
  build?: () => Promise<{ blob: Blob; filename: string }>;
}) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const root = document.querySelector(rootSelector) as HTMLElement | null;
    if (!root && !build) return;
    setBusy(true);
    try {
      const { blob, filename: served } = build
        ? await build()
        : await printExport.xlsx(extractPrintSheet(root!, (filename || defaultPrintFilename(root!)).trim()));
      saveBlob(blob, served);
    } catch {
      window.alert('Не вдалося сформувати файл Excel — спробуйте ще раз');
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={() => void run()} disabled={busy}
      title="Зберегти цю форму файлом Excel (.xlsx) — таблиці й реквізити як на екрані">
      {busy ? 'формування…' : 'зберегти в Excel'}
    </button>
  );
}
